const indiaDate = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" });
const indiaClock = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export const dateInIndia = (now = new Date(), offsetDays = 0) =>
  indiaDate.format(new Date(now.getTime() + offsetDays * 24 * 60 * 60 * 1000));

export const hourInIndia = (now = new Date()) => Number(indiaClock.format(now).slice(0, 2));

// The office clears rider collections first thing in the morning; after 10 AM
// the day's new orders would be mixed into yesterday's figures.
export const beforeTenInIndia = (now = new Date()) => hourInIndia(now) < 10;

export const dayRange = (date) => ({ from: `${date} 00:00:00`, to: `${date} 00:00:00` });

export const monthStartInIndia = (now = new Date()) => `${dateInIndia(now).slice(0, 7)}-01`;
